// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__AustinMediumWeb_e700fd', '__AustinMediumWeb_Fallback_e700fd'"},"className":"__className_e700fd","variable":"__variable_e700fd"};